import React from 'react';
export var PlayCircle = function PlayCircle(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("path", {
    d: "M24,5c10.5,0,19,8.5,19,19s-8.5,19-19,19S5,34.5,5,24S13.5,5,24,5 M24,1C11.3,1,1,11.3,1,24s10.3,23,23,23s23-10.3,23-23\n    S36.7,1,24,1L24,1z"
  }), React.createElement("path", {
    d: "M17,35.4V12.6L37,24L17,35.4z M21,19.4v9.1l8-4.6L21,19.4z"
  }));
};